import {GET, POST} from "@/services/gateway";

const list = ({pagination, search, filter}) => {
  return POST('box/user/list', {pagination, search, filter});
}

const getStatus = () => {
  return GET('box/user/status');
}

const refresh = () => {
  return GET('box/user/refresh');
}

const backupAll = () => {
  return GET('box/user/backup/all')
}

const protectAll = () => {
  return POST('box/user/protect');
}

const unprotectAll = () => {
  return POST('box/user/unprotect');
}
const changeStatus = ({status, id}) => {
  return POST('box/user/userstatus/change', {status, id});
}

const exportSnapshot = (filter, search, pagination) => {
  const currentDate = new Date();

  return POST('box/user/export', {filter, search, pagination, TimeZoneOffset: currentDate.getTimezoneOffset()})
}

export {
  list,
  refresh,
  getStatus,
  protectAll,
  unprotectAll,
  backupAll,
  changeStatus,
  exportSnapshot
}
